// Ensure Inter font stylesheet is included (idempotent).
// Used both by the external embed API and when the widget is mounted as a React component.

export const ensureInterStylesheet = (): void => {
    if (typeof document === 'undefined') return;

    const ID = 'hl-oc-inter-font';

    if (!document.getElementById(ID)) {
        const link = document.createElement('link');
        link.id = ID;
        link.rel = 'stylesheet';
        link.href =
            'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap';

        document.head.appendChild(link);
    }

    // CSP / load failure detection (non-blocking)
    if ('fonts' in document) {
        setTimeout(() => {
            document.fonts
                .load('1em Inter')
                .then((fonts) => {
                    if (!fonts || fonts.length === 0) {
                        // eslint-disable-next-line no-console
                        console.warn(
                            '[HL OC Widget] Inter font failed to load. Falling back to system fonts. ' +
                            'This is often caused by a restrictive Content Security Policy.',
                        );
                    }
                })
                .catch(() => {
                    // Silently ignore — we never want fonts to break the widget
                });
        }, 0);
    }
};

